<button class="menu" [ngClass]="{'thumb': thumb}" mat-icon-button [matMenuTriggerFor]="imageActionsMenu"><mat-icon>more_vert</mat-icon></button>

<mat-menu #imageActionsMenu="matMenu">
  <button mat-menu-item (click)="replaceImage()">{{'BUTTONS.REPLACE' | translate}}</button>
  <button mat-menu-item (click)="deleteImage()">{{'BUTTONS.DELETE' | translate}}</button>
</mat-menu>
